import { OverflowTooltip } from '@adsk/alloy-react-tooltip';
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { translate } from '../../helpers';
import { useGetRfiTypeName } from '../../hooks/rfiTypesHooks';
import { RfiType } from '../../sdk/types';
import { InlineLoader, LoaderStyle } from '../InlineLoader';

const SpinnerLoadingWrapper = styled.div({
  paddingLeft: '12px',
  height: '36px',
  display: 'flex',
  alignItems: 'center',
});

export type RfiTypeCellProps = {
  rfiTypeId: RfiType['id'];
  loaderStyle?: LoaderStyle;
};

export type RenderRfiTypeCellProps = {
  rfiTypeName: string;
  isLoading: boolean;
  isError: boolean;
  loaderStyle?: LoaderStyle;
};

export const renderRfiTypeCell = ({
  rfiTypeName,
  isLoading,
  isError,
  loaderStyle = LoaderStyle.Text,
}: RenderRfiTypeCellProps) => {
  if (isError) {
    return <OverflowTooltip>{translate('error.general')}</OverflowTooltip>;
  }

  if (isLoading) {
    return loaderStyle === LoaderStyle.Spinny ? (
      <SpinnerLoadingWrapper>
        <InlineLoader loaderStyle={loaderStyle} />
      </SpinnerLoadingWrapper>
    ) : (
      <InlineLoader loaderStyle={loaderStyle} />
    );
  }

  return <OverflowTooltip>{rfiTypeName}</OverflowTooltip>;
};

export const RfiTypeCell: FunctionComponent<RfiTypeCellProps> = ({
  rfiTypeId,
  loaderStyle = LoaderStyle.Text,
}) => {
  const { rfiTypeName, isLoading, isError } = useGetRfiTypeName(rfiTypeId);

  return renderRfiTypeCell({ rfiTypeName, isLoading, isError, loaderStyle });
};
